<div *ngIf="!isLoading">
  <div class="content-container">
    <div class="primary-container grid-container weighted-left">
      <div class="column-container">
        <dxo-card-responsive
          [bodyHeader]="PrimaryCardHeader"
          *ngIf="accountManagerCard"
          class="contacts-card"
          data-e2e="primary-card-header"
        >
          <card-body data-e2e="account-manager-card-body">
            <div class="contact-info-container">
              <img class="primary" src="/v1/profile/photo?email={{ accountManagerCard.email }}" alt="Profile pic" />
              <div class="contact-info">
                <div class="name-number">
                  <dxo-label-value
                    class="primary"
                    [label]="accountManagerCard.contactType"
                    [values]="[accountManagerCard.name]"
                  />
                  <dxo-button
                    class="phone-button"
                    [textButton]="true"
                    [href]="'tel:+1-' + accountManagerCard.phoneNumber"
                    [text]="accountManagerCard.phoneNumber"
                  ></dxo-button>
                </div>
              </div>
            </div>
            <div class="email-button-div">
              <div class="min-width">
                <dxo-button
                  class="email-button"
                  [primary]="accountManagerCard.primaryButton"
                  [icon]="accountManagerCard.emailIcon"
                  [iconColor]="accountManagerCard.primaryButton ? 'white' : 'blue'"
                  [text]="accountManagerCard.email"
                  (handleClick)="copyEmail(accountManagerCard)"
                  data-e2e="account-manager-email-button"
                ></dxo-button>
              </div>
              <div class="copy-text-container">
                <div *ngIf="accountManagerCard.showCopyEmailText" class="copy-text">
                  {{ EmailCopyText }}
                </div>
              </div>
            </div>
          </card-body>
        </dxo-card-responsive>
      </div>

      <div class="column-container">
        <dxo-card-responsive [bodyHeader]="ClaimsCardHeader" class="claims-card" data-e2e="claims-card-header">
          <card-body class="contact-card-body">
            <div>
              <dxo-button
                class="phone-button claims"
                [textButton]="true"
                [href]="'tel:+1-' + ClaimsPhone"
                [text]="ClaimsPhone"
                [icon]="phoneIcon"
                iconColor="gray"
              >
              </dxo-button>
              <div class="divider"></div>
              <div class="claims-icon-text-container">
                <dxo-icon color="gray" fontSize="24">{{ faxIcon }}</dxo-icon>
                <div class="fax">
                  {{ ClaimsFax }}
                </div>
              </div>
              <div class="divider"></div>
              <div class="claims-icon-text-container">
                <dxo-icon color="gray" fontSize="24">{{ clockIcon }}</dxo-icon>
                <div class="hours-container">
                  <div class="hours">
                    {{ ClaimsHours1 }}
                  </div>
                  <div class="hours">
                    {{ ClaimsHours2 }}
                  </div>
                </div>
              </div>
              <div class="divider"></div>
              <div class="claims-icon-text-container">
                <dxo-icon color="gray" fontSize="24">{{ officeIcon }}</dxo-icon>
                {{ ClaimsAddress1 }}
                <br />
                {{ ClaimsAddress2 }}
                <br />
                {{ ClaimsAddress3 }}
              </div>
            </div>
            <div class="email-button-div">
              <dxo-button
                class="email-button"
                [icon]="claimsCard.emailIcon"
                iconColor="gray"
                [text]="ClaimsEmail"
                (handleClick)="copyEmail(claimsCard)"
                data-e2e="claims-department-email-button"
              ></dxo-button>
              <div class="copy-text-container">
                <div *ngIf="claimsCard.showCopyEmailText" class="copy-text">
                  {{ EmailCopyText }}
                </div>
              </div>
            </div>
          </card-body>
        </dxo-card-responsive>
      </div>
    </div>

    <div class="secondary-container grid-container double-even">
      <div class="column-container">
        <dxo-card-responsive
          *ngIf="salesRepCard"
          [bodyHeader]="SalesRepCardHeader"
          class="contacts-card"
          data-e2e="sales-rep-card-header"
        >
          <card-body data-e2e="sales-rep-card-body">
            <div class="contact-info-container">
              <img src="/v1/profile/photo?email={{ salesRepCard.email }}" alt="Profile pic" />
              <div class="contact-info">
                <div class="name-number">
                  <dxo-label-value [label]="SalesRepLabel" [values]="[salesRepCard.name]" />
                  <dxo-button
                    class="phone-button"
                    [textButton]="true"
                    [href]="'tel:+1-' + salesRepCard.phoneNumber"
                    [text]="salesRepCard.phoneNumber"
                  ></dxo-button>
                </div>
              </div>
            </div>
            <div class="email-button-div">
              <dxo-button
                class="email-button"
                [primary]="salesRepCard.primaryButton"
                [icon]="salesRepCard.emailIcon"
                iconColor="gray"
                [text]="salesRepCard.email"
                (handleClick)="copyEmail(salesRepCard)"
                data-e2e="sales-rep-email-button"
              ></dxo-button>
              <div class="copy-text-container">
                <div *ngIf="salesRepCard.showCopyEmailText" class="copy-text">
                  {{ EmailCopyText }}
                </div>
              </div>
            </div>
          </card-body>
        </dxo-card-responsive>
      </div>

      <div class="column-container">
        <dxo-card-responsive
          [bodyHeader]="CustomerSupportCardHeader"
          class="contacts-card"
          data-e2e="customer-support-card-header"
        >
          <card-body data-e2e="customer-support-card-body">
            <div class="contact-info-container">
              <img src="/assets/images/default-profile-image.svg" alt="Profile pic" />
              <div class="contact-info">
                <div class="name-number">
                  <dxo-label-value [label]="CustomerSupportLabel" [values]="[portalSupportCard.name]" />
                  <dxo-button
                    class="phone-button"
                    [textButton]="true"
                    [href]="'tel:+1-' + portalSupportCard.phoneNumber"
                    [text]="portalSupportCard.phoneNumber"
                  ></dxo-button>
                </div>
              </div>
            </div>
            <div class="email-button-div">
              <dxo-button
                class="email-button"
                [primary]="portalSupportCard.primaryButton"
                [icon]="portalSupportCard.emailIcon"
                iconColor="gray"
                [text]="portalSupportCard.email"
                (handleClick)="copyEmail(portalSupportCard)"
                data-e2e="portal-support-email-button"
              ></dxo-button>
              <div class="copy-text-container">
                <div *ngIf="portalSupportCard.showCopyEmailText" class="copy-text">
                  {{ EmailCopyText }}
                </div>
              </div>
            </div>
          </card-body>
        </dxo-card-responsive>
      </div>
      <div class="column-container" *ngFor="let item of brokersCard; index as contactIndex">
        <dxo-card-responsive
          *ngIf="item"
          [bodyHeader]="BrokerCardHeader"
          class="contacts-card"
          data-e2e="broker-card-header"
        >
          <card-body data-e2e="broker-card-body">
            <div class="contact-info-container">
              <div class="contact-info">
                <div class="name-number">
                  <dxo-label-value [label]="BrokerLabel" [values]="[item.name]" />
                  <dxo-button
                    class="phone-button"
                    [textButton]="true"
                    [href]="'tel:+1-' + item.phoneNumber"
                    [text]="item.phoneNumber"
                  ></dxo-button>
                </div>
              </div>
            </div>
            <div class="email-button-div">
              <dxo-button
                class="email-button"
                [icon]="item.emailIcon"
                iconColor="gray"
                [text]="item.email"
                (handleClick)="copyEmail(item, contactIndex)"
                data-e2e="broker-email-button"
              ></dxo-button>
              <div class="copy-text-container">
                <div *ngIf="item.showCopyEmailText" class="copy-text">
                  {{ EmailCopyText }}
                </div>
              </div>
            </div>
          </card-body>
        </dxo-card-responsive>
      </div>
    </div>
  </div>
</div>
<div *ngIf="isLoading" class="loader-container">
  <dxo-circular-loader [size]="'medium'" [color]="'blue'"></dxo-circular-loader>
</div>
